import { render } from "./ContactUsConfirmation.vue?vue&type=template&id=2bb9cde4&scoped=true"
import script from "./ContactUsConfirmation.vue?vue&type=script&lang=js"
export * from "./ContactUsConfirmation.vue?vue&type=script&lang=js"

import "./ContactUsConfirmation.vue?vue&type=style&index=0&id=2bb9cde4&lang=scss&scoped=true"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb9cde4"]])

export default __exports__